import { createFileRoute } from "@tanstack/react-router";
import { RegistryPage } from "@/features/registry/registry-page";

export const Route = createFileRoute("/app/w/$weddingId/registry")({ component: RegistryPage });
